import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_EDIT_VENUE_MUTATION = gql`
  mutation Post(
    $id: String!,
    $venueSlugName: String!,
    $venueName: String,
    $venueReadableName: ObjectLocalizationInput,
    $description: ObjectLocalizationInput,
    $image: ObjectLocalizationInput,
    $postUri: String,
    $address: String,
    $location: String,
    $country: String,
    $phone: String,
    $latitude: Float,
    $longitude: Float,
    $capacity: Int,
    ) {
    postEditVenue(
      id: $id,
      venueSlugName: $venueSlugName,
      venueName: $venueName,
      venueReadableName: $venueReadableName,
      description: $description,
      image: $image,
      postUri: $postUri,
      address: $address,
      location: $location,
      country: $country,
      phone: $phone,
      latitude: $latitude,
      longitude: $longitude,
      capacity: $capacity,
      ) {
      isAuth
      isEdited
      venueSlugName
    }
  }
`;

const postEditVenue = async ({
  id,
  venueSlugName,
  venueName,
  venueReadableName,
  description,
  image,
  postUri,
  address,
  location,
  country,
  phone,
  latitude,
  longitude,
  capacity,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_EDIT_VENUE_MUTATION,
      variables: {
        id,
        venueSlugName,
        venueName,
        venueReadableName,
        description,
        image,
        postUri,
        address,
        location,
        country,
        phone,
        latitude,
        longitude,
        capacity,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postEditVenue: postEditVenueValidationData } } = result;

    if (postEditVenueValidationData) {
      return postEditVenueValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditVenueValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditVenue Error: ${error}`);
    return null;
  }
};

export default postEditVenue;
